<template>
  <div class="footer">
    <div class="footer-wrap w1200">
      <div class="left" style="margin-top: 50px">
        <!-- <h4>联系我们</h4>
        <div class="concat">
          <p>客服电话：400-720-8888</p>
          <p>邮&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;编：201203</p>
          <p>
            地&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;址：上海市浦东新区张衡路666弄1号9楼
          </p>
        </div> -->
        <h4>集团公司</h4>
        <a target="_blank" href="http://www.zenmen.com/"
          ><img class="group-icon" :src="groupIcon" alt=""
        /></a>
        <h4>集团旗下公司</h4>
        <div class="com-icon-list">
          <a target="_blank" href="https://www.wifi.com/"
            ><img :src="icon1" alt=""
          /></a>
          <a target="_blank" href="https://www.shengpay.com/"
            ><img :src="icon2" alt=""
          /></a>
          <a target="_blank" href="http://www.igeak.com/#/"
            ><img :src="icon3" alt=""
          /></a>
          <a target="_blank" href="http://www.sangotek.com/"
            ><img :src="icon4" alt=""
          /></a>
        </div>
      </div>
      <div class="right">
        <div class="code-list">
          <li>
            <img :src="code1" alt="" />
            <p>SHENGPAYET公众号</p>
          </li>
          <li>
            <img :src="code2" alt="" />
            <p>留学缴费通APP</p>
            <span class="download-desc">下载地址</span>
          </li>
          <li>
            <img :src="code3" alt="" />
            <p>官方联系微信</p>
          </li>
        </div>
        <div class="sft-desc">
          <div class="sft">
            <a target="_blank" href="https://www.shengpay.com/">
              <img :src="logo" alt="" />
              <p>旗下公司</p>
            </a>
          </div>
          <div class="addr">
            <p>上海境汇信息技术有限公司</p>
            <!-- <p>网站备案号：</p> -->
          </div>
        </div>
      </div>
    </div>
    <div class="site-icp">
      <img :src="iconGA" />
      <a
        target="_blank"
        href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011502017039"
        >沪公网备31011502017039号</a
      ><a href="https://beian.miit.gov.cn/" target="_blank"
        >沪ICP备20001761号-5</a
      >
    </div>
  </div>
</template>
<script setup lang="ts">
const groupIcon = new URL(
  "../../assets/img/footer/group-icon.png",
  import.meta.url
).href;
const icon1 = new URL("../../assets/img/footer/icon1.png", import.meta.url)
  .href;
const icon2 = new URL("../../assets/img/footer/icon2.png", import.meta.url)
  .href;
const icon3 = new URL("../../assets/img/footer/icon3.png", import.meta.url)
  .href;
const icon4 = new URL("../../assets/img/footer/icon4.png", import.meta.url)
  .href;
const code1 = new URL("../../assets/img/footer/jht_code.png", import.meta.url)
  .href;
const code2 = new URL("../../assets/img/footer/lxjft_code.png", import.meta.url)
  .href;
const code3 = new URL(
  "../../assets/img/footer/gflxwx_code.png",
  import.meta.url
).href;
const logo = new URL("../../assets/img/footer/logo.png", import.meta.url).href;
const iconGA = new URL(
  "../../assets/img/footer/icon_gongan.png",
  import.meta.url
).href;
</script>
<style lang="scss" scoped>
.footer {
  min-width: 1200px;
  background: #2e2e2e;
  height: 420px;
  box-sizing: border-box;
  padding-bottom: 31px;
  overflow: hidden;
  position: relative;
  display: none;

  .footer-wrap {
    min-width: 1200px;
    max-width: 1200px;
    margin: 0 auto;
    box-sizing: border-box;
    position: relative;
    margin-top: 44px;
    display: flex;
    .left {
      flex: 1;
      h4 {
        font-size: 20px;
        color: #a0a0a0;
        line-height: 26px;
      }

      .concat {
        margin-top: 9px;
        margin-bottom: 22px;

        p {
          font-size: 14px;
          line-height: 26px;
          color: #e6e6e6;
        }
      }

      .group-icon {
        margin: 20px 0px 25px 0px;
      }
      .com-icon-list {
        padding-top: 20px;
        padding-bottom: 31px;
        img {
          margin-right: 12px;
        }
      }
    }
    .right {
      .code-list {
        display: flex;
        width: 462px;
        justify-content: space-between;
        margin-top: 40px;
        li {
          p {
            text-align: center;
            color: #d7d7d7;
            font-size: 14px;
            margin-top: 7px;
            margin-bottom: 7px;
          }
          a {
            width: 111px;
            height: 31px;
            background: #2e2e2e;
            border: 1px solid #444444;
            border-radius: 2px;
            color: #e6e6e6;
            font-size: 14px;
            line-height: 31px;
            text-align: center;
            &:hover {
              color: #0085f1;
            }
          }
          .download-desc {
            width: 111px;
            height: 31px;
            background: #2e2e2e;
            color: #e6e6e6;
            font-size: 14px;
            line-height: 31px;
            text-align: center;
          }
        }
      }
      .sft-desc {
        display: flex;
        justify-content: flex-end;
        margin-top: 22px;
        flex-direction: column;
        .sft {
          a {
            display: flex;
            justify-content: flex-end;
            p {
              font-size: 17px;
              color: #d0d0d0;
              line-height: 24px;
              margin-left: 8px;
            }
          }
        }
        .addr {
          margin-top: 16px;
          text-align: right;
          p {
            color: #e6e6e6;
            font-size: 14px;
            line-height: 26px;
          }
        }
      }
    }
  }
}
.site-icp {
  text-align: center;
  width: 100%;
  position: absolute;
  bottom: 10px;
  // padding-top: 10px;
  img {
    width: 20px;
    vertical-align: middle;
  }
  a {
    color: #999;
    display: inline-block;
    padding-left: 10px;
  }
}
</style>
